import React from 'react'
import Select, { StylesConfig } from "react-select";

const ProductServicesTab = ({ isReadOnly, leadsInquiryLookups, formik,getdefaultLookups }: any) => {

  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <div className="card ">
            <div className="card-body card-css">
              <h5 className='mb-2'>
                The Airoom Companies - Products & Services
              </h5>
              <div>
                <label className='input-label'>Property Type</label>
                <Select
                  styles={customStyles}
                  className="select"
                  options={leadsInquiryLookups?.result?.Lst_PropertyType?.map((option: any) => ({
                    label: option?.value,
                    value: option?.id
                  }))}
                  value={
                    formik.values?.lst_PropertyType?.id
                      ? {
                        value: formik.values?.lst_PropertyType?.id,
                        label: formik.values?.lst_PropertyType?.value || '',
                      }
                      : null
                  }
                  isDisabled={isReadOnly}
                  onChange={(selectedOption: any) => {
                    formik.setFieldValue('lst_PropertyType.id', selectedOption.value);
                    formik.setFieldValue('lst_PropertyType.value', selectedOption.label);
                  }}
                />
              </div>
              <div>
                <label className='input-label'>Airoom Product & Services</label>
                <Select
                  styles={customStyles}
                  className="select"
                  options={getdefaultLookups?.result?.Lst_AiroomProductServices
                    ?.map((option: any) => ({
                    label: option?.value,
                    value: option?.id
                  }))}
                  value={
                    formik.values?.lst_AiroomProductAndServices?.id
                      ? {
                        value: formik.values?.lst_AiroomProductAndServices?.id,
                        label: formik.values?.lst_AiroomProductAndServices?.value || '',
                      }
                      : null
                  }
                  isDisabled={isReadOnly}
                  onChange={(selectedOption: any) => {
                    formik.setFieldValue('lst_AiroomProductAndServices.id', selectedOption.value);
                    formik.setFieldValue('lst_AiroomProductAndServices.value', selectedOption.label);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-6'>
          <div className='card'>
            <div className='card-body card-css'>
              <h5 className='mb-2'>
                The Airoom Companies - (Products Options)
              </h5>
              <div className='row'>
                <div className="col-md-12 ">
                  <label className='input-label'>The Airoom Companies - (Products Options)</label>
                  <Select
                    styles={customStyles}
                    className="select"
                  options={leadsInquiryLookups?.result?.Lst_AiroomCompaniesProduct?.map((option: any) => ({
                    label: option?.value,
                    value: option?.id
                  }))}
                  value={
                    formik.values?.lst_AiroomCompanies?.id
                      ? {
                        value: formik.values?.lst_AiroomCompanies?.id,
                        label: formik.values?.lst_AiroomCompanies?.value || '',
                      }
                      : null
                  }
                  isDisabled={isReadOnly}
                  onChange={(selectedOption: any) => {
                    formik.setFieldValue('lst_AiroomCompanies.id', selectedOption.value);
                    formik.setFieldValue('lst_AiroomCompanies.value', selectedOption.label);
                  }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default ProductServicesTab